import { render, staticRenderFns } from "./updater.vue?vue&type=template&id=d8187936&scoped=true&"
import script from "./updater.vue?vue&type=script&lang=js&"
export * from "./updater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8187936",
  null
  
)

export default component.exports